import { render, staticRenderFns } from "./notAgreed.vue?vue&type=template&id=76c86972"
import script from "./notAgreed.vue?vue&type=script&lang=js"
export * from "./notAgreed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports